import { useEffect } from "react";
var ToggleShowEnrollmentErrorHook = function (isAccountFeaturesLoading, shouldShowPaperFee, isAccountFeaturesError, dispatch) {
    useEffect(function () {
        if (!isAccountFeaturesLoading &&
            (shouldShowPaperFee === null || isAccountFeaturesError)) {
            dispatch({ showEnrollmentError: true });
        }
        else {
            dispatch({ showEnrollmentError: false });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldShowPaperFee, isAccountFeaturesError, isAccountFeaturesLoading]);
};
export default ToggleShowEnrollmentErrorHook;
